import { Controller } from "@hotwired/stimulus"

let scriptPromise

function loadTurnstile() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile)
  }

  scriptPromise ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")
    const timeout = setTimeout(() => reject(new Error("Turnstile loading timed out")), 15000)
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
    script.async = true
    script.onload = () => {
      clearTimeout(timeout)
      resolve(window.turnstile)
    }
    script.onerror = () => {
      clearTimeout(timeout)
      reject(new Error("Turnstile could not load"))
    }
    document.head.appendChild(script)
  })

  return scriptPromise
}

export default class extends Controller {
  static get targets() {
    return ["widget", "submit", "status"]
  }

  static get values() {
    return { siteKey: String, action: String, pendingMessage: String, errorMessage: String }
  }

  async connect() {
    this.active = true
    this.submitting = false
    this.widgetId = null
    this.block(this.pendingMessageValue)

    try {
      const turnstile = await loadTurnstile()
      if (!this.active) {
        return
      }

      this.widgetId = turnstile.render(this.widgetTarget, {
        sitekey: this.siteKeyValue,
        action: this.actionValue,
        theme: "light",
        size: "flexible",
        callback: () => {
          this.verified = true
          this.submitTarget.disabled = this.submitting
          this.statusTarget.textContent = ""
        },
        "expired-callback": () => this.block(this.pendingMessageValue),
        "timeout-callback": () => this.block(this.pendingMessageValue),
        "error-callback": () => {
          this.block(this.errorMessageValue)
          return true
        },
        "unsupported-callback": () => this.block(this.errorMessageValue)
      })
    } catch {
      if (this.active) {
        this.block(this.errorMessageValue)
      }
    }
  }

  disconnect() {
    this.active = false
    if (this.widgetId !== null) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }

  submit(event) {
    if (!this.verified || this.submitting) {
      event.preventDefault()
      return
    }

    this.submitting = true
    this.submitTarget.disabled = true
  }

  restore(event) {
    if (event.persisted && this.widgetId !== null) {
      this.submitting = false
      this.block(this.pendingMessageValue)
      window.turnstile.reset(this.widgetId)
    }
  }

  block(message) {
    this.verified = false
    this.submitTarget.disabled = true
    this.statusTarget.textContent = message
  }
}
